import { graphql } from '@/generated/gql';

export const LOAD_SMART_LINKS_QUERY = graphql(/* GraphQL */ `
  query LoadSmartLinks($domain: AstroSmartLinkDomain!) {
    astronaut {
      smartLinks(domain: $domain) {
        id
        updatedAt
        title
        domain
        url
        description
        external
        hidden
        variant
        sequence
      }
    }
  }
`);
